<template>
  <div class="sidebar-box mt-6 p-1">
    <h6 class="mb-3 p-2 cursor-pointer" data-toggle="collapse" data-target="#brands-filter-1">
      {{ $t('filter.brand.title') }}
      <i class="bi bi-arrow-down-circle"></i>
    </h6>

    <div class="filter-brand-1-selected-items-filter">
      <span v-for="(item,index) in selectedBrandsObject"
            @click="removeBrandFromFilter(index)"
            class="filter-brand-1-selected-items-filter-item badge badge-primary rounded-pill mx-1 cursor-pointer">
        {{ item.name }}
        <i class="bi bi-x-circle-fill"/>
      </span>
    </div>


    <div id="brands-filter-1" class="p-2 collapse">
      <div class="form-group form-check" v-for="brand in brandsObject" :key="brand.id">
        <input v-model="selectedBrands" @change="emitData" :value="brand[brandColumn]" name="filter_brands"
               type="checkbox"
               class="form-check-input" :id="`brand_filter_${brand.id}`">
        <label class="form-check-label mr-3" :for="`brand_filter_${brand.id}`">{{ brand.name }}</label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FilterBrand1",
  props: {
    productBrands: {
      default: null
    },
    brandColumn: {
      default: 'id',
      validator(value) {
        // The value must match one of these strings
        return ['id', 'slug'].includes(value)
      }
    },
    brandsObject: {
      default: []
    },
    dirtyRoute: {
      default: false
    }
  },
  data() {
    return {
      selectedBrands: [],
      selectedBrandsObject: [],
    }
  },
  methods: {
    manageSelectedBrandObject() {
      this.selectedBrandsObject = []
      this.brandsObject.forEach(item => {
        let selectedBrandsTemp = this.selectedBrands.map(item => item.toString())

        if (selectedBrandsTemp.indexOf(item.slug) > -1 && this.brandColumn === 'slug') {
          this.selectedBrandsObject.push(item)
        }
        if (selectedBrandsTemp.indexOf(item.id.toString()) > -1 && this.brandColumn === 'id') {
          this.selectedBrandsObject.push(item)
        }


      })
    },
    getBrandIds() {
      let ids = [];
      this.brandsObject.forEach(item => {
        let selectedBrandsTemp = this.selectedBrands.map(item => item.toString())
        if (selectedBrandsTemp.indexOf(item.id.toString()) > -1) {
          ids.push(item.id)
        }
      })
      return ids.length > 0 ? ids : null
    },
    getBrandSlugs() {
      let slugs = [];
      this.brandsObject.forEach(item => {
        if (this.selectedBrands.indexOf(item.slug) > -1) {
          slugs.push(item.slug)
        }
      })
      return slugs.length > 0 ? slugs : null
    },
    filterOutput() {
      if (this.brandColumn === 'id') {
        return this.getBrandIds();
      }
      if (this.brandColumn === 'slug') {
        return this.getBrandSlugs();
      }
    },
    emitData() {
      this.setDirtyRoute()
      this.$emit('brands', this.filterOutput())
    },
    setDirtyRoute() {
      if (this.dirtyRoute) {


        let brands = {brand: this.selectedBrands.join(',')};
        const newQuery = {
          ...this.$route.query,
          ...brands
        }
        this.manageSelectedBrandObject()
        this.$router.push({query: newQuery});
      }


    },
    removeBrandFromFilter(brandIndex) {
      const updatedBrands = [...this.selectedBrands];
      updatedBrands.splice(brandIndex, 1);
      this.selectedBrands = updatedBrands;
      this.emitData()
    }
  },
  async mounted() {
    if (this.productBrands != null) {
      this.selectedBrands = this.productBrands
    }
  },
  watch: {
    brandsObject: {
      handler(oldValue, newValue) {
        this.manageSelectedBrandObject()
      },
      deep: true
    },
    selectedBrands: {
      handler(oldValue, newValue) {
        this.manageSelectedBrandObject()
      },
      deep: true
    },
  }

}
</script>

<style scoped>

.sidebar-box {
  border-radius: 10px;
  background: white;
  box-shadow: 0px 5px 25px rgba(218, 211, 211, 0.3);
  margin-bottom: 30px;
  border: 1px solid #F5F4F4;
}

.cursor-pointer {
  cursor: pointer;
}

</style>